import { Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { Toast, ToastType } from 'app/models/toast.model';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public queue: WritableSignal<Toast[]> = signal<Toast[]>([]);
  private readonly DEFAULT_DURATION = 3000;

  public success(input: { title: string, subtitle?: string, duration?: number } | string) {
    const id = this.generateId();
    let title: string;
    let subtitle: string | undefined;
    let duration: number;
    if (typeof input === 'string') {
      title = 'Успешно';
      subtitle = input;
      duration = this.DEFAULT_DURATION;
    } else {
      title = input.title;
      subtitle = input.subtitle;
      duration = input.duration || this.DEFAULT_DURATION;
    }
    this.queue.set([{ type: ToastType.SUCCESS, title, subtitle, duration, id }, ...this.queue()]);
    this.startTimer(id, duration);
  }

  public error({ title, subtitle, duration }: { title: string, subtitle?: string, duration?: number }) {
    const id = this.generateId();
    this.queue.set([{ type: ToastType.ERROR, title, subtitle, duration: duration || this.DEFAULT_DURATION, id },...this.queue()]);
    this.startTimer(id, duration || this.DEFAULT_DURATION);
  }

  private generateId() {
    return Math.random().toString(36).substring(2, 15);
  }

  private startTimer(id: string, duration: number) {
    setTimeout(() => {
      this.removeToast(id);
    }, duration);
  }

  public removeToast(id: string) {
    if (!this.queue().find((toast) => toast.id === id)) return;
    this.queue.set(this.queue().filter((toast) => toast.id !== id));
  }
}